import React from 'react';
import MenuAppBar from '../components/MenuAppBar'

const Todo = () =>{
    return(
        <div>
            <MenuAppBar pageTitle="TODO" />
            <h1>This is todo page</h1>
        </div>  
    );
}

export default Todo;